/* eslint-disable @typescript-eslint/no-explicit-any */
import { globals } from "@/main";
import { requestLoginHeader } from "../requests/header.request";
import { api } from "@/dto/api.endpoint.dto";
import {
  apiErrorResponse,
  apiSuccessResponse,
} from "@/services/requests/response.request";

export const getLocalizeService = async (): Promise<any> => {
  const headers = await requestLoginHeader;

  return await globals.$axios
    .get(api.listLocalizations + "?app=3", {
      headers,
    })
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};
